import type {
  ActivityFeedItem,
  AnalyticsOverview,
  CampusActivityItem,
  DashboardOverview,
  TimeseriesPoint,
} from '@/types/stats.types';

import { apiClient } from './api.service';

export const statsApi = {
  overview: () =>
    apiClient.get<DashboardOverview>('/admin/stats/overview').then((r) => r.data),

  timeseries: (days: number) =>
    apiClient.get<TimeseriesPoint[]>('/admin/stats/timeseries', { params: { days } }).then((r) => r.data),

  campusActivity: () =>
    apiClient.get<CampusActivityItem[]>('/admin/stats/campus-activity').then((r) => r.data),

  activityFeed: () =>
    apiClient.get<ActivityFeedItem[]>('/admin/stats/activity-feed').then((r) => r.data),

  analytics: () => apiClient.get<AnalyticsOverview>('/admin/stats/analytics').then((r) => r.data),
};
